import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const DefineKRA = () => {
  const [count, setCount] = useState(1);
  const [kra_category, setKra_category] = useState("");
  const [weightageList, setWeightageList] = useState<any>([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [showKraTable, setShowKraTable] = useState(false);
  const [kraData, setKraData] = useState<any>([]);
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (_: any, __: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
    },
    {
      title: "Category",
      dataIndex: "category_name",
      render: (text: string) => <p>{text}</p>,
      sorter: (a: any, b: any) =>
        a.category_name.localeCompare(b.category_name),
    },
    {
      title: "Smart Goals",
      dataIndex: "smart_goals",
      render: (text: string) => (
        <span style={{ width: "max-content" }}>{text}</span>
      ),
      sorter: (a: any, b: any) => a.smart_goals.localeCompare(b.smart_goals),
    },
    {
      title: "Target",
      dataIndex: "target",
      sorter: (a: any, b: any) =>
        new Date(a.target).getTime() - new Date(b.target).getTime(),
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      render: (text: string) => <p>{text === null ? 0 : text}%</p>,
      sorter: (a: any, b: any) =>
        parseFloat(a.weightage) - parseFloat(b.weightage),
    },
    // {
    //   title: "Action",
    //   dataIndex: "actions",
    //   render: (_: any, record: any) => (
    //     <div className="action-icon d-inline-flex">
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#edit_weightage"
    //         onClick={() => setSelectedItem(record)}
    //       >
    //         <i className="ti ti-edit" />
    //       </Link>
    //       <Link
    //         to="#"
    //         className="me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#delete_modal"
    //         onClick={() => setSelectedItem(record)}
    //       >
    //         <i className="ti ti-trash" />
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  const columns_kraList = [
    {
      title: "Category",
      dataIndex: "category_name",
      render: (text: string, record: any, index: number) => <p>{text}</p>,
      sorter: (a: any, b: any) =>
        a.category_name.localeCompare(b.category_name),
    },
    {
      title: "Smart Goal",
      dataIndex: "smart_goals",
      render: (text: string, record: any, index: number) => (
        <p style={{ minWidth: "160px" }}>{text}</p>
      ),
      sorter: (a: any, b: any) => a.smart_goals.localeCompare(b.smart_goals),
    },
    {
      title: "Target",
      dataIndex: "target",
      render: (text: string, record: any, index: number) => (
        <p style={{ minWidth: "140px" }}>{text}</p>
      ),
      sorter: (a: any, b: any) => a.target.localeCompare(b.target),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      render: (text: string, record: any, index: number) => (
        <div className="d-flex gap-1 align-items-center">
          <input
            type="text"
            className="form-control w-75"
            value={text}
            placeholder="Weightage"
            onChange={(e) => handleWeightageChange(index, e.target.value)}
          />{" "}
          %
        </div>
      ),
      sorter: (a: any, b: any) =>
        parseFloat(a.weightage) - parseFloat(b.weightage),
    },
  ];

  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-category", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
  });

  useEffect(() => {
    setCategoryList(getcategoryResponse?.data);
  }, [getcategoryResponse]);

  const getInputData = (e: any) => { };

  const {
    data: viewKRAResponse,
    loading: viewKRALoading,
    error: viewKRAError,
    callApi: viewWeiKraDetails,
  } = useApi("/api/manager/view-weightage-kra", {
    method: "POST",
    autoCall: false,
    dependencies: [count],
  });

  const getCraData = async (e: any) => {
    e.preventDefault();
    if (kra_category === "") {
      Swal.fire({
        icon: "warning",
        title: "Please select a category",
        text: "You need to choose a category before proceeding.",
        confirmButtonText: "OK",
      });
      return;
    }
    const payload = {
      category_id: kra_category,
      financial_year: finance_year,
    };
    try {
      const response = await viewWeiKraDetails(payload);
      console.log(response);
      if (response.success) {
        setKraData(response?.data);
        setShowKraTable(true);
      }
    } catch (error) { }
  };

  const handleWeightageChange = (index: number, value: string) => {
    const parsedValue = parseFloat(value);
    const updated = [...kraData]; // Change here to use kraData

    // Prevent error if index is invalid
    if (!updated[index]) return;

    updated[index].weightage = value;

    const newTotal = updated.reduce((acc, item, i) => {
      const weight = parseFloat(item.weightage);
      return acc + (i === index ? parsedValue : weight);
    }, 0);

    if (newTotal > 100) {
      Swal.fire({
        icon: "warning",
        title: "Weightage Limit Exceeded",
        text: "Total weightage cannot exceed 100%",
        confirmButtonText: "OK",
      });
      return;
    }

    setKraData(updated); // Update kraData instead of kraList
  };

  const CalculatetotalWeightage = kraData?.reduce((acc: any, item: any) => {
    const num = parseFloat(item?.weightage);
    return acc + num;
  }, 0);

  const {
    data: viewWeightageKRAResponse,
    loading: viewWeightageKRALoading,
    error: viewWeightageKRAError,
  } = useApi("/api/manager/view-weightage-kra", {
    method: "POST",
    payload: {
      category_id: "",
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [count],
  });

  useEffect(() => {
    if (viewWeightageKRAResponse?.success) {
      setWeightageList(viewWeightageKRAResponse?.data);
    }
  }, [viewWeightageKRAResponse]);

  const {
    data: addweightageKRAResponse,
    loading: addweightageKRALoading,
    error: addweightageKRAError,
    callApi: addweightageKRA,
  } = useApi("/api/manager/add-weightage-kra", {
    method: "POST",
    autoCall: false,
  });

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    // Calculate total weightage
    const totalWeightage = kraData.reduce((acc: number, item: any) => {
      const weight = parseFloat(item.weightage) || 0;
      return acc + weight;
    }, 0);

    // Validate total = 100
    if (totalWeightage !== 100) {
      Swal.fire({
        icon: "error",
        title: "Invalid Total Weightage",
        text: `Total weightage must be exactly 100%. Currently it is ${totalWeightage}%.`,
        confirmButtonText: "OK",
      });
      return;
    }
    const weightage_data = kraData.map((item: any) => ({
      kra_id: item.kra_id,
      weightage: item.weightage,
    }));
    const payload = {
      category_id: kra_category,
      weightage_data,
    };
    try {
      const response = await addweightageKRA(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("close_modal")?.click();
        setCount(count + 1);
        setKra_category("");
        setWeightageList([]);
        setKraData([]);
      }
    } catch (error) {
      console.error("Error while adding :", error);
    }
  };

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
    try {
    } catch (error) {
      console.error("Error while updating :", error);
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">KRA Weightage</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Goal Settings</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    KRA Weightage
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_category"
                  className="btn btn-primary custom_button d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add KRA Weightage
                </Link>
              </div>
            </div>
          </div>
          {/* <div className="mb-3 bg-white rounded-3 p-3 shadow-sm"></div> */}
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>KRA Weightage List</h5>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={weightageList}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Modal */}
      <div className="modal fade" id="add_category">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ width: "90%", maxWidth: "800px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Add KRA Weightage </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={AddNewItem}>
              <div className="modal-body pb-0 pb-4">
                <div className="row p-0">
                  <div className="col-md-12 ps-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <select
                        name="kra_category"
                        id="kra_category"
                        className="form-select"
                        onChange={(e: any) => {
                          setKra_category(e.target.value);
                        }}
                        value={kra_category}
                      >
                        <option value="">Select Category</option>
                        {categoryList?.map((item: any, index: any) => (
                          <option value={item.category_id}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn-primary custom_button px-3 py-1 rounded-2"
                      onClick={getCraData}
                    >
                      Submit
                    </button>
                  </div>
                  {showKraTable && kraData.length > 0 && (
                    <>
                      <div className="mt-4">
                        <div className="card">
                          <div className="card-body">
                            <h4>List of KRA</h4>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <p className="fs-16">
                            Total:{" "}
                            <strong className="text-b">
                              {CalculatetotalWeightage || 0}
                            </strong>{" "}
                            %
                          </p>
                        </div>
                        <Table
                          dataSource={kraData}
                          columns={columns_kraList}
                          Selection={false}
                        />
                      </div>
                      <div className="modal-footer mt-3">
                        <button
                          type="button"
                          className="btn btn-light me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          // data-bs-dismiss="modal"
                          className="btn btn-primary custom_button"
                        >
                          Add Weightage
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
      <div className="modal fade" id="edit_weightage">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ width: "90%", maxWidth: "800px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">
                Edit KRA Weightage
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0 pb-4">
                <div className="row p-0">
                  <div className="col-md-12 ps-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <select
                        name="category_id"
                        id=""
                        className="form-select"
                        onChange={getInputData}
                      >
                        <option value="">Select Category</option>
                        {categoryList?.map((item: any, index: any) => (
                          <option value={item.category_id}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn-primary custom_button px-3 py-1 rounded-2"
                      onClick={getCraData}
                    >
                      Submit
                    </button>
                  </div>
                  {showKraTable && (
                    <>
                      <div className="mt-4">
                        <h4>List of KRA</h4>
                        <div className="d-flex justify-content-end">
                          <p className="fs-16">
                            Total:{" "}
                            <strong className="text-b">
                              {/* {CalculatetotalWeightage} */}
                            </strong>{" "}
                            %
                          </p>
                        </div>
                        <Table
                          dataSource={[]}
                          columns={columns_kraList}
                          Selection={false}
                        />
                      </div>
                      <div className="modal-footer mt-3">
                        <button
                          type="button"
                          className="btn btn-light me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          // data-bs-dismiss="modal"
                          className="btn btn-primary"
                        >
                          Add Weightage
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="modal-footer mt-3">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefineKRA;
